const DEV_GOOGLE_API_KEY = process.env.REACT_APP_DEVELOPMENT_GOOGLE_API_KEY;
const PRODUCTION_GOOGLE_API_KEY =
  process.env.REACT_APP_PRODUCTION_GOOGLE_API_KEY;

export const getGoogleApiToken = (): string => {
  return process.env.NODE_ENV === 'production'
    ? PRODUCTION_GOOGLE_API_KEY ?? ''
    : DEV_GOOGLE_API_KEY ?? '';
};
